import axios from 'axios';
import errorMessage from './errorMessage';
import {
  GET_LEADERBOARD_SCORES_REQUEST,
  GET_LEADERBOARD_SCORES_SUCCESS,
  GET_LEADERBOARD_SCORES_FAILURE,

  GET_LEADERBOARD_SCORES_LIST_REQUEST,
  GET_LEADERBOARD_SCORES_LIST_SUCCESS,
  GET_LEADERBOARD_SCORES_LIST_FAILURE,

  GET_LEADERBOARD_RESET_SORTING,
  RESET_TRIBUN_SCORES
} from 'Store/constants';
import LocalStorage from 'Utils/localStorage';
import ProjectConfig from 'ProjectConfig';
import { replaceUrlWithPublicUrl } from 'Utils/replaceUrlWithPublicUrl';
import EnvironmentManager from 'Utils/environmentManager';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getLeaderBoardScores = tribunUserId => async (dispatch, getState) => {

  const user = getState().auth.data;

  const headers = {
    channel: '0'
  };

  try {
    dispatch({
      type: GET_LEADERBOARD_SCORES_REQUEST
    });

    const res = await axios({
      url: replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/leaderboard/scores/user/${tribunUserId}`),
      method: 'get',
      headers: headers
    });

    dispatch({
      type: GET_LEADERBOARD_SCORES_SUCCESS,
      payload: res.data.score
    });

  } catch (e) {

    dispatch({
      type: GET_LEADERBOARD_SCORES_FAILURE,
      payload: errorMessage
    });
  }
};

export const getLeaderBoardScoresList = (page, pageSize) => async (dispatch, getState) => {

  const user = getState().auth.data;

  const headers = {
    channel: '0'
  };
  
  try {
    dispatch({
      type: GET_LEADERBOARD_SCORES_LIST_REQUEST
    });

    const sortType = LocalStorage.get('tribunLeaderbordSortOption') || 'TOTAL_SCORE';


    const res = await axios({
      url: replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/leaderboard/scores?page=${page}&pageSize=${pageSize}&scoreType=${sortType}`),
      method: 'get',
      headers: headers
    });


    if (!res.data.leaderboardResponse.scores) {
      return dispatch({
        type: GET_LEADERBOARD_SCORES_LIST_FAILURE,
        lastPage: true
      });
    }

    dispatch({
      type: GET_LEADERBOARD_SCORES_LIST_SUCCESS,
      payload: res.data,
      lastPage: res.data.leaderboardResponse.scores.length < pageSize
    });

  } catch (e) {

    dispatch({
      type: GET_LEADERBOARD_SCORES_LIST_FAILURE,
      lastPage: true,
      payload: errorMessage
    });
  }
};

export const resetSorting = ()=> async dispatch => {
  dispatch({
    type: GET_LEADERBOARD_RESET_SORTING
  });
};

export const resetTribunScores = () => async dispatch => {
  dispatch({
    type: RESET_TRIBUN_SCORES
  });
};

export const getLeaderboardSortingMenuItems = () => [
  {
    name: EnvironmentManager.getMessageText({ key: 'tribun_leaderboard_tab1_name' }),
    value: 'TOTAL_SCORE',
    checked: true
  },
  {
    name: EnvironmentManager.getMessageText({ key: 'tribun_leaderboard_tab2_name' }),
    value: 'WIN_SCORE',
    checked: false
  },
  {
    name: EnvironmentManager.getMessageText({ key: 'tribun_leaderboard_tab3_name' }),
    value: 'RATE_SCORE',
    checked: false
  },
  {
    name: EnvironmentManager.getMessageText({ key: 'tribun_leaderboard_tab4_name' }),
    value: 'PLAY_WIN_SCORE',
    checked: false
  },
  {
    name: EnvironmentManager.getMessageText({ key: 'tribun_leaderboard_tab5_name' }),
    value: 'PREDICTION_SCORE',
    checked: false
  },
];